import React from 'react';
import { LOCATIONS_PAGE } from '../lib/queries';
import client from '../lib/apolloClient';
import Layout from '../src/components/Layout/Layout';
import LocationsComponent from '../src/components/Locations/Locations';
import replacePictureUrlWithSignedUrl from '../src/utils/replaceUrlWithSigned/replaceUrlWithSigned';

const Locations = (props) => {
  const { data } = props;
  return (
    <Layout>
      <LocationsComponent data={data} />
    </Layout>
  );
};

export default Locations;

export async function getServerSideProps() {
  let { data } = await client.query({ query: LOCATIONS_PAGE });
  data = await replacePictureUrlWithSignedUrl(data);
  return {
    props: { data },
  };
}
